import { useStorageContext } from '@app/contexts/storage';
import { MAIN_PAGE } from '@app/enums';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';

interface IModalErrorUnathenthicatedProps {}

export const ModalErrorUnathenthicated: FunctionComponent<IModalErrorUnathenthicatedProps> = observer<FunctionComponent<IModalErrorUnathenthicatedProps>>(function () {
    const { globalStorage } = useStorageContext();

    let openModalErrorUnathenthicated = globalStorage.openErrorUnAuthenticated;

    return (
        <Dialog open={openModalErrorUnathenthicated} onClose={() => globalStorage.handleCloseErrorUnauthenticated()} aria-describedby='alert-dialog-description'>
            <DialogContent>
                <DialogContentText id='alert-dialog-description'>You've been logged out. Please, log in again.</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        globalStorage.handleCloseErrorUnauthenticated();
                        globalStorage.openModule = MAIN_PAGE.LOGOUT;
                        globalStorage.openErrorUnAuthenticated = false;
                        globalStorage.LogOutIconClicked = true;
                    }}
                    size={'small'}
                    color='primary'>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
});
